








































import settings from '@/settings'
import m from '@/graphql/mutation'
import q from '@/graphql/query'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import af from '@/utils/authorized_formats'

export default {
    name: 'interview_files_modal'

    props:
        component:
            type: String
            required: true
        interview:
            required: true
        dialog_visible:
            required: true

    watch:
        dialog_visible: (new_one, old_one)->
            @visible = new_one
            # console.log "DIALOG CHANGE", @visible

    data: ()->
        alert: false
        visible: false
        errors: {}
        true: true
        max_filesize: af['interview_file']['filename']['max_filesize']/1024/1024
        files: []
        file: {
            uid: ''
            interview_uid: @interview.uid
            name: ''
            filename_data: ''
            filename_name: ''
            filesize: 0
            filetype: ''
        }

    computed:
        save_text: ()->
            text = "Ajouter"
            if @file.uid != ''
                text = "Enregistrer"
            return text

    methods:
        file_icon: (f)->
            return af['interview_file']['types'][f.filetype]['icon']

        reset_file: ()->
            @file = {
                uid: ''
                interview_uid: @interview.uid
                name: ''
                filename_data: ''
                filename_name: ''
                filesize: 0
                filetype: ''
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        handle_file_remove: (file, fileList)->
            @$refs.interview_file_upload.clearFiles()
            @reset_file()
            return

        handle_file_change: (file, fileList)->
            is_good_size = file.size < af['interview_file']['filename']['max_filesize']

            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e.target.result
                self.file.filename_data = e.target.result
                self.file.filename_name = file.name
                self.file.filesize = file.size
                self.file.filetype = file.raw.type
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @file
            return

        download_file: (file)->
            url = settings.media_url+file.filename_dir+'/'+file.filename
            filename = file.complete_filename
            t.download_file(url, filename)
            return

        handle_close: (done)->
            # console.log "CLOSE", done
            @reset_file()
            @files = []
            @visible = false
            @$emit("close-file-modal")

        handle_open: ()->
            # console.log "HANDLE OPEN"
            @get_interview_files()

        edit_file: (file)->
            @file = file
            # console.log "EDIT FILE", file

        delete_file: (file_uid)->
            # console.log "DELETE FILE", file_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce document ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "INTERVIEW DELETE FILE", file_uid
                    m.run('delete_object', ['interview_file', file_uid])
                    .then (resp)->
                        # console.log "DELETE INTERVIEW FILE", resp.body.data.object_deletion
                        if resp.body.data.interview_file_deletion.ok
                            n.success()
                            self.get_interview_files()
                        else
                            n.gql_error("interview_files_modal: delete_file: then", resp.body.data.interview_file_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "interview_files_modal: delete_file()")
                .catch (cancel)->
                    return

        save: ()->
            @file.interview_uid = @interview.uid
            # console.log "SAVE INTERVIEW FILE", @file
            self = @
            if @file.uid == "" and @file.filename_name == ""
                n.file_error('Erreur', 'Un fichier est requis')
                return
            type_prefix = @file.filetype.split('/')[0]
            if type_prefix in ['image', 'video', 'audio']
                @file.filetype = type_prefix
            else if af.application_types.hasOwnProperty(@file.filetype)
                @file.filetype = af.application_types[@file.filetype]
            else
                @file.filetype = 'other'
            m.run('save_interview_file', [@file])
            .then (resp)->
                if resp.body.data.interview_file_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.interview_file_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.interview_file_form_mutation.errors
                    self.errors = resp.body.data.interview_file_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_file()
                    self.$refs.interview_file_upload.clearFiles()
                    self.get_interview_files()
            .catch (resp)->
                n.catch_error(resp, "interview_files_modal: save()")

        get_interview_files: ()->
            self = @
            q.run('get_interview_file_set', [@interview.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("interview_files_modal: get_interview_files: then", e.message)
                else
                    # console.log "GET interviews : ", resp.body.data.interview_file_set
                    self.files = resp.body.data.interview_file_set
                    if self.files.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "interview_files_modal: get_interview_files()")

    # mounted: ()->
    #     console.log "INTERVIEW FILES MOUNTED ", @interview
}
